import React from 'react';
// Constants
import { CompanyName, LocationCity } from '../../utils/Constants';
// Data
import {
  groundworksPageAdditionalMeta,
  groundworksPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/headers/GeneralHeader';
import GroundworksPageMainContainer from '../../components/groundworks/GroundworksPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function GroundworksPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Groundworks'
        desc={`Get in touch with ${CompanyName} for expert groundworks services in ${LocationCity}. Whether you need site preparation, excavation, or drainage work, we’re here to help.`}
        keywords={`groundworks, excavation, site preparation, drainage, ${CompanyName}, quotes, inquiries, ${LocationCity}, UK`}
        additionalMeta={groundworksPageAdditionalMeta}
        structuredData={groundworksPageStructuredData}
      />

      <div className='grid min-h-screen overflow-hidden bg-colour3 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <GeneralHeader ServiceName='Groundworks' bgImage={'bg-groundwork'} />

          {/* Main page content */}
          <GroundworksPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default GroundworksPage;
